import { performRequest } from "../performRequest"



export const getAllSalaryApi = (params) => {
    return performRequest("get", "api/ess/salary/",params)
}

export const getSalaryDetailApi = (id, params) => {
    return performRequest("get", `api/ess/salary/${id}/`,params)
}

